import { List, NavBar } from 'antd-mobile'

import { 
    BodyView,
    ListView,
    NavBarTitleView,
    OptionView,
    PopupSelectView
} from "../../factory/ViewUtil";

import { 
    WithdrawIcon,
    TransferIcon,
    RechargeIcon,
    MoreR4Icon
 } from "../../icons";

import { 
    CellAssetsView,
    CellHeaderView,
    CellStateView,
    CellRecordView

 } from "../../factory/CellViews";
import React, { useEffect, useState } from 'react';
import { isLogin, RequestTradeRecord } from '../../../NetworkFactory';
import { DecimalComparedToZero, DecimalConvert, ToDate } from '../../factory/FactoryUtil';
import { AssetsGetName, AssetsListener, AssetsListenerRemove } from '../AssetsManager';

const AssetsAccountViewController = ({goback, loginpush, navpush, data}) => {
    
    const optionData = [
        {
            title : 'Recharge',
            icon : <RechargeIcon/>,
            onClick : () => {
                navpush('/recharge')
            }
        },
        {
            title : 'Transfer',
            icon : <TransferIcon/>,
            onClick : () => {
                loginpush('/assets/transfer', false, {type : type})
            }
        },
        {
            title : 'Withdraw',
            icon : <WithdrawIcon/>,
            onClick : () => {
                navpush('/withdraw', false, {type : type})
            }
        }
    ];
    const type = data.type
    const [itemData, setItemData] = useState(data.data || {});
    const [stateCode, setStateCode] = useState(3);
    const [dataSource, setDataSource] = useState([]);

    const [visiblePopup, setVisiblePopup] = useState(false);
    const [assetsData, setAssetsData] = useState([]);

    const requestData = () => {
        setStateCode(3)
        RequestTradeRecord(type, itemData.symbol).then(response => {
            const data = response.data.data || []
            setStateCode(data.length >0 ? -1 : 1)
            setDataSource(data)
            
        }).catch(()=> {
            setStateCode(1)
        })
    }
    useEffect(() => {
        if(isLogin()) {
            requestData()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getRecordType = (item = {}) => {
        let recordTitle = ''
        const {type = 0, symbol, target} = item || {}

        // # 期货
        if(data.type === '1') {
            if(type === '100') {
                recordTitle = symbol + ' to ' + target + ' deduct'
            }
            else if(type === '101') {
                recordTitle = target + ' to ' + symbol + ' entry'
            }
            else if(type === '102') {
                recordTitle = symbol + ' to ' + target + ' freeze'
            }
            else if(type === '103') {
                recordTitle = symbol + ' to ' + target + ' undo'
            }
            else if(type === '200') {
                recordTitle = symbol + ' recharge'
            }
            else if(type === '201') {
                recordTitle = symbol + ' recharge refuse'
            }
        }
        // # 合约
        else if(data.type === '2') {
            if(type === '105') {
                recordTitle = symbol + ' Buy ' + target + ' commission'
            }
            else if(type === '100') {
                recordTitle = symbol + ' Buy ' + target + ' loss'
            }
            else if(type === '101') {
                recordTitle = target + ' Buy ' + symbol + ' profited'
            }
            else if(type === '102') {
                recordTitle = symbol + ' Buy ' + target + ' margin freeze'
            }
            else if(type === '104') {
                recordTitle = symbol + ' Buy ' + target + ' margin unseal'
            }
        }
        // # 秒合约
        else if(data.type === '3') {
            if(type === '102') {
                recordTitle = symbol + ' Buy ' + target + ' margin freeze'
            }
            else if(type === '104') {
                recordTitle = symbol + ' Buy ' + target + ' margin unseal'
            }
            else if(type === '100') {
                recordTitle = symbol + ' Buy ' + target + ' loss'
            }
            else if(type === '101') {
                recordTitle = target + ' Buy ' + symbol + ' profited'
            }
        }

        // 其他
        if(type === '110') {
            recordTitle = symbol + ' transfer in'
        }
        else if(type === '111') {
            recordTitle = symbol + ' transfer out'
        }
        else if(type === '210') {
            recordTitle = symbol + ' withdraw under review'
        }
        else if(type === '211') {
            recordTitle = symbol + ' withdraw success'
        }
        else if(type === '212') {
            recordTitle = symbol + ' withdraw refuse'
        }
        else if(type === '213') {
            recordTitle = symbol + ' withdraw refuse unseal'
        }
        return recordTitle
    }

    const openAccount = (item)=> {
        setVisiblePopup(false)
        setItemData(item)
    }

    useEffect(() => {
        if(isLogin()) {
            AssetsListener(type, 'AssetsAccountViewController', response => {
                setAssetsData(response.data || [])
            })
            return () => {
                AssetsListenerRemove(type, 'AssetsAccountViewController')
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>
                    <NavBarTitleView onClick={()=>{setVisiblePopup(true)}} icon={<MoreR4Icon/>}>{AssetsGetName(type)} Account</NavBarTitleView>
                </NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    <CellAssetsView item = {itemData} style={{marginTop : '20px'}}/>
                    <List.Item style={{margin : '40px  0'}}><OptionView data={optionData}/></List.Item>
                    <CellHeaderView>Transaction records</CellHeaderView>
                    <CellRecordView left='Amount' center='Record' right='Time' color='#B0B0B0' style={{margin: '20px 0'}}/>
                    <CellStateView stateType={stateCode} onRefresh={()=>{requestData()}}/> 
                    {
                        dataSource.map((item, index) => (
                            <CellRecordView 
                            key={index} 
                            border={true} 
                            left={<span style={{color : DecimalComparedToZero(item.amount) < 0 ? '#D92727' : '#08BF89'}}>{DecimalConvert(item.amount)}</span>} 
                            center={getRecordType(item)} 
                            right={<span style={{color : '#999'}}>{ToDate(item.creationDate)}</span>}/>
                        ))
                    }
                </ListView>
            </BodyView>
            <PopupSelectView visible={visiblePopup} close={()=>{setVisiblePopup(false)}}>
                {
                    assetsData.map((item, index) => (
                        <CellAssetsView onClick={()=>{openAccount(item)}} key={index} item={item}/>
                    ))
                }
            </PopupSelectView>
        </>
    );
}
export default React.memo(AssetsAccountViewController)